import { categories } from "@/mocks/content";

export default function Categories() {
  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mb-10 max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-layout-grid-fill"></i>
            六大栏目
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            想看哪种乐子，任你挑
          </h2>
          <p className="mt-3 text-sm text-foreground-700 md:text-base">
            从魔改解说、神吐槽到沙雕图集和弹幕梗，火影黄本子把火影世界的笑点全给你搬来了。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {categories.map((c) => (
            <article
              key={c.title}
              className="group rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                  {c.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-xl text-foreground-950">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}